/**
 * MRP RM Parameters (/mrp/rm-params) — input page.
 *
 * List (search / pagination / has-vendor filter) + add/edit dialog
 * (MOQ, batch, lead time, safety stock, yield factor, preferred vendor)
 * + template download + bulk upload.
 */
import MRPDashboard from '@/pages/MRPDashboard';

export default function MRPRMParams() {
  return <MRPDashboard view="rm-params" />;
}
